import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const CachedDropdownsState = {
  dropdowns: {},
  isWaiting: null,
  queue: {},
}

// http://localhost:3000/options/spouses/immigration_status

export const CachedDropdownsActions = {
  getDropdownOptions: async ({ commit, dispatch, getters }, { path, options = true, force = false }) => {
    if (!force && getters.hasCachedDropdown(path)) return getters.getCachedDropdown(path)

    if (!getters.isWaiting) {
      setTimeout(_ => { dispatch('loadDropdowns') }, 500)
      commit('setIsWaiting', true)
    }

    commit('addToQueue', {
      key: path,
      call: options ? `/options/${path}` : `/${path}`,
      success: ({ data }) => {
        if (Array.isArray(data)) commit('setCachedDropdown', { key: path, options: data })
        else commit('setCachedDropdown', { key: path, options: data?.options || [] })
      },
      error: handleError,
    })
  },

  getSurveyDropdownOptions: async ({ commit, dispatch, getters }, { session, options: { path, options = true, force = false } }) => {
    if (!force && getters.hasCachedDropdown(path)) return getters.getCachedDropdown(path)

    if (!getters.isWaiting) {
      setTimeout(_ => { dispatch('loadDropdowns') }, 500)
      commit('setIsWaiting', true)
    }

    commit('addToQueue', {
      key: path,
      call: options ? `/survey/${session}/options/${path}` : `/survey/${session}/root_options/${path}`,
      success: ({ data }) => {
        if (Array.isArray(data)) commit('setCachedDropdown', { key: path, options: data })
        else commit('setCachedDropdown', { key: path, options: data?.options || [] })
      },
      error: handleError,
    })
  },

  loadDropdowns: async ({ commit, getters }) => {
    // for (const item of getters.getQueue) {
    //   axiosRequest.get(item.call).then(item.success).catch(item.error)
    //   commit('removeFromQueue', item.key)
    // }
    for (const identifier of getters.getQueueIdentifiers) {
      const item = getters.getQueue(identifier)
      axiosRequest.get(item.call).then(item.success).catch(item.error)
      commit('removeFromQueue', identifier)
    }

    commit('setIsWaiting', false)
  },
}

export const CachedDropdownsMutations = {
  addToQueue: (state, { key, call, success, error }) => { Vue.set(state.queue, key, { call, success, error }) },
  removeFromQueue: (state, key) => { Vue.delete(state.queue, key) },
  setCachedDropdown: (state, { key, options }) => {
    Vue.set(state.dropdowns, key, {
      options,
      lastUpdated: Date.now(),
    })
  },
  setIsWaiting: (state, value) => { state.isWaiting = value },
}

export const CachedDropdownsGetters = {
  getCachedDropdown: state => model => state.dropdowns[model]?.options || [],
  getQueue: state => key => state.queue[key],
  getQueueIdentifiers: state => Object.keys(state.queue),
  hasCachedDropdown: state => model => !!state.dropdowns[model],
  isWaiting: state => state.isWaiting,
}
